export * from './IconThree';
export { default as IconThree } from './IconThree';
